/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneFormRequestId';
const QS_TYPE: QueryStateSchema['type'] = 'formRequest';

export const useOpenFormRequestPane = (): ((args: { formRequestId: string }) => void) => {
  const [formRequestIdDeprecated, setFormRequestId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (formRequestIdDeprecated) {
      setFormRequestId(null);
      setState(backwardsCompatabilityFactory({ id: formRequestIdDeprecated, type: QS_TYPE }));
    }
  }, [formRequestIdDeprecated]);

  return ({ formRequestId }) => {
    setState(prevState => [...(prevState || []), {
      id: formRequestId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
